import React from 'react'
import _ from 'underscore'
import { Receipt } from 'lucide-react'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import CombineOrders from './combine'
import SalesOrderPartial from './partial'
import store from '../../../state/store'

class SalesOrder extends React.Component {

  componentDidMount() {
    store.emit('orders:index', this.props.enquiry_id)
  }

  onCombineOrders = (order_ids) => {
    const params =  {
      order_ids: order_ids,
      enquiry_id: this.props.enquiry_id
    }

    store.emit('orders:combine', params)
  }

  onDelete = (order_id) => {
    const params = {
      enquiry_id: this.props.enquiry_id,
      order_id: order_id
    }

    store.emit('orders:delete', params)
  }

  onShare = (order_id) => {
    const params = {
      enquiry_id: this.props.enquiry_id,
      order_id: order_id
    }

    store.emit('orders:share', params)
  }

  render() {
    return(
      <Card>
        <CardHeader className="flex items-center">
          <CardTitle className="flex items-center gap-2">
            <Receipt className="size-4" />
            Orders
          </CardTitle>
          <CardAction className="ml-auto self-center">
            <CombineOrders
              enquiry_id={this.props.enquiry_id}
              orders={this.props.orders}
              onCombineOrders={this.onCombineOrders}
            />
          </CardAction>
        </CardHeader>
        <CardContent>
          <table className="data-table data-table--compact mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>Description</th>
                <th>Payment Term</th>
                <th>Total</th>
                <th>Status</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {_.map(this.props.orders, (order) => {
                return(
                  <SalesOrderPartial
                    key={order.id}
                    order={order}
                    onDelete={this.onDelete}
                    onShare={this.onShare}
                  />
                )
              })}
            </tbody>
          </table>
        </CardContent>
      </Card>
    )
  }
}

export default SalesOrder
